<template>
  <div class="waybill waybill_fuels">

    <div class="waybill__fuel" v-for="fuel in fuels" :key="fuel.id">
      <strong>{{ fuel.name }}</strong>
      <div class="form__inputs form__inputs_col-3">
        <AppInput title="Начальное значение"
                  width="100%"
                  :value="fuel.balance_at"
                  @value-changed="setAt(...arguments, fuel.id)"
        />
        <AppInput title="Заправка"
                  width="100%"
                  :value="fuel.balance_add"
                  @value-changed="setAdd(...arguments, fuel.id)"
        />
        <AppInput title="Конечное значение"
                  width="100%"
                  :value="fuel.balance_to"
                  @value-changed="setTo(...arguments, fuel.id)"
        />
        <p></p>
        <p></p>
        <p class="waybill__fuel-overall">Итоговый расход: {{calcOverall(fuel.balance_at, fuel.balance_add, fuel.balance_to)}}</p>
      </div>
    </div>

  </div>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import calcOverall from '@/utils/filters/calcOverall'

export default {
  name: 'LogisticWaybillFuels',
  components: { AppInput },
  props: {
    fuels: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    calcOverall,

    setAdd (value, id) {
      const data = { value, id }
      this.$emit('set-balance-add', data)
    },

    setTo (value, id) {
      const data = { value, id }
      this.$emit('set-balance-to', data)
    },

    setAt (value, id) {
      const data = { value, id }
      this.$emit('set-balance-at', data)
    }
  }
}
</script>

<style lang="scss" scoped>

.page__item {
  width: 33%;
}

.page__row {
  max-width: 834px;
  margin-bottom: 10px;
}

.waybill__fuel {
  margin-bottom: 20px;
}

.waybill__fuel-overall {
  font-size: 14px;
  text-align: right;
  max-width: 834px;
}

</style>
